import React from 'react'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'

const GlobalSection: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 })

  return (
    <section className="py-20 bg-white">
      <div
        ref={ref}
        className="container mx-auto px-6"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
        }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Simplifying a Globalized World
          </h2>
          <div className="text-lg text-gray-600 leading-relaxed space-y-4">
            <p>
              Cap Gains transforms complex international investment calculations into your
              home currency. Whether you're trading stocks, receiving dividends, or
              exchanging currencies, we handle all your cross-border transaction
              calculations.
            </p>
            <p>
              You will see your international gains in your home currency in just a few
              easy steps.
            </p>
            <p>
              Stop juggling multiple spreadsheets and calculators. Cap Gains handles all
              your international investment calculations in one place.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GlobalSection
